var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }